var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from '../elements/svg-circle-icon';
export var IndicatorIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 61,
    glyphHeight: 58,
    glyphOffsetY: 14
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.497 57.2653V17.4473H17.9256V55.3833C20.662 56.3104 23.5311 56.9497 26.497 57.2653ZM9.35414 51.2822V26.0187H0.782715V43.973C3.27702 46.7919 6.1625 49.2566 9.35414 51.2822ZM43.6399 55.3833C40.9035 56.3104 38.0343 56.9497 35.0684 57.2653V8.87587H43.6399V55.3833ZM52.2113 51.2822C55.4029 49.2566 58.2884 46.7919 60.7827 43.973V0.304443H52.2113V51.2822Z",
    fill: "black"
  }));
};
export var IndicatorIconGlyph = function (props) {
  return React.createElement(IndicatorIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};